import { render, staticRenderFns } from "./AirTransport_Component.vue?vue&type=template&id=4437f1ba&scoped=true&"
import script from "./AirTransport_Component.vue?vue&type=script&lang=js&"
export * from "./AirTransport_Component.vue?vue&type=script&lang=js&"
import style0 from "./AirTransport_Component.vue?vue&type=style&index=0&id=4437f1ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4437f1ba",
  null
  
)

export default component.exports